<span class="cf-dlg-section__label">Clasificación de gasto por defecto</span>

<app-loading-state *ngIf="loading" [compact]="true" message="Cargando clasificación…"></app-loading-state>

<div class="cec-error" *ngIf="!loading && loadError">
  <span>No se pudo cargar la clasificación.</span>
  <button mat-stroked-button type="button" (click)="retry()"><mat-icon>refresh</mat-icon> Reintentar</button>
</div>

<div class="cec" *ngIf="!loading && !loadError">
  <p class="cec-hint">
    Al elegir este proveedor en un gasto, las líneas que aún no tengan partida, subpartida y familia las toman de aquí.
    Lo que ya hayas puesto en una línea no se cambia.
  </p>

  <div class="cec-grid">
    <mat-form-field appearance="outline">
      <mat-label>Partida</mat-label>
      <mat-select [(ngModel)]="partida" [ngModelOptions]="{standalone: true}" (selectionChange)="onPartidaChange()">
        <mat-option *ngFor="let p of catalog" [value]="p.nombre">{{ p.nombre }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="subpartidas.length">
      <mat-label>Subpartida</mat-label>
      <mat-select [(ngModel)]="subpartida" [ngModelOptions]="{standalone: true}" (selectionChange)="onSubpartidaChange()">
        <mat-option *ngFor="let s of subpartidas" [value]="s.nombre">{{ s.nombre }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="familias.length">
      <mat-label>Familia</mat-label>
      <mat-select [(ngModel)]="familia" [ngModelOptions]="{standalone: true}">
        <mat-option [value]="null">Sin familia</mat-option>
        <mat-option *ngFor="let f of familias" [value]="f">{{ f }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="cec-warn" *ngIf="saveError">{{ saveError }}</div>

  <div class="cec-actions">
    <button mat-stroked-button type="button" (click)="clear()" [disabled]="saving || !partida">
      <mat-icon>close</mat-icon> Quitar
    </button>
    <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving">
      <mat-icon>save</mat-icon> Guardar clasificación
    </button>
  </div>
</div>
